import { FC } from 'react'
import { Briefcase } from '@emotion-icons/fa-solid/Briefcase'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { ReportedOwnersWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/reported-owners/reported-owners'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { Colors } from 'src/components/theme'

const ReportedOwnersInsight: FC<InsightComponentProps> = ({ insight }) => {
  return (
    <InsightContainer insight={insight} color={Colors.primaryGreen700} iconBgColor={Colors.primaryGreen700}>
      <ReportedOwnersWidget />
    </InsightContainer>
  )
}

export const ReportedOwners: Insight = {
  id: 'reported-owners',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['parcel-reported-owners-tab'],
  component: ReportedOwnersInsight,
  name: 'Reported Owners',
  icon: Briefcase,
  linkTooltipFile: 'reported-owners',
  supportedResultTypes: ['parcel'],
}
